import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-613bc398"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "switch-tips"
};
const _hoisted_2 = {
  key: 0,
  class: "tips"
};
const _hoisted_3 = {
  class: "dialog-footer"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定");

import { useVModel } from '@vueuse/core';
import { deepClone } from '@/plugins/utils';
export default /*#__PURE__*/_defineComponent({
  props: {
    // 是否显示
    isEditTitle: Boolean,
    fieldsForm: Object,
    // 是否是添加
    isAdd: {
      type: Boolean,
      default: true
    },
    isDelete: {
      type: Boolean,
      default: true
    },
    tips: {
      type: String,
      default: ''
    }
  },
  emits: ['update:isEditTitle', 'handleTitleDel', 'handleTitleSave'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const showDialog = useVModel(props, 'isEditTitle', emit);
    const formRef = ref();
    const form = ref({
      field_title: '',
      status: 0
    });
    const rules = {
      field_title: [{
        required: true,
        message: '请输入名称',
        trigger: 'blur'
      }]
    };

    const handleClose = () => {
      showDialog.value = false;
    };

    const handleDelete = () => {
      emit('handleTitleDel', form.value);
    };

    const handleTitleSave = () => {
      formRef.value.validate(async valid => {
        if (valid) {
          emit('handleTitleSave', form.value, props.isAdd);
          handleClose();
        }
      });
    };

    watch(() => showDialog.value, async val => {
      if (val) {
        await nextTick();
        formRef.value.clearValidate();
        props.fieldsForm && (form.value = deepClone(props.fieldsForm));
      } else {
        form.value = {
          field_title: '',
          status: 0
        };
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(showDialog),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(showDialog) ? showDialog.value = $event : null),
        title: __props.isAdd ? '添加新模块' : '编辑',
        width: "500px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          class: "btn",
          onClick: handleClose
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), __props.isDelete && !__props.isAdd ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "btn",
          type: "warning",
          onClick: handleDelete
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          class: "btn",
          type: "primary",
          onClick: handleTitleSave
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          "label-width": "60px",
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名称",
            prop: "field_title"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.field_title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.field_title = $event),
              placeholder: "请输入名称",
              style: {
                "width": "380px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), !__props.isAdd && __props.isDelete ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "开关",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.value.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.status = $event),
              "active-value": 1,
              "inactive-value": 0,
              "active-color": "var(--el-color-primary)",
              "inactive-color": "#dddddd"
            }, null, 8, ["modelValue"]), _createElementVNode("span", _hoisted_1, _toDisplayString(form.value.status === 1 ? '关闭后网页上将隐藏该模块内容' : '打开后网页上将显示该模块内容'), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"]), __props.isAdd && __props.tips ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.tips), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }

});